import { useQuery } from '@tanstack/react-query';

import { INews, INewsCategory, INewsSingle } from '../models';
import { getAllArticles, getAllNewsCategory, getNewsBySlug, getRecommendedNews } from '../queries';
import { articleCons } from '..';

export const useAllNews = ({
  page,
  languageId,
  categoryId,
  size
}: {
  page?: string | string[];
  languageId: number;
  categoryId?: string | string[] | undefined;
  size?: number;
}) => {
  const { data, ...arg } = useQuery<{ news: INews }>({
    queryKey: [articleCons.queryKeys.ARTICLES, { page, categoryId, languageId }],
    queryFn: getAllArticles({ page, languageId, categoryId, size })
  });

  return { ...data, ...arg };
};

export const useAllNewsCategory = (languageId: number) => {
  const { data: newsCategory, ...arg } = useQuery<INewsCategory[]>({
    queryKey: [articleCons.queryKeys.ARTICLES_CATEGORY, languageId],
    queryFn: getAllNewsCategory(languageId)
  });

  return { newsCategory, ...arg };
};

export const useNewsBySlug = (slug?: string) =>
  useQuery<INewsSingle>({
    queryKey: [articleCons.queryKeys.ARTICLE_BY_SLUG, slug],
    queryFn: getNewsBySlug(slug)
  });

export const useRecommendedNews = (articleSlug?: string) =>
  useQuery<INews>({
    queryKey: [articleCons.queryKeys.RECOMMENDED_ARTICLES, articleSlug],
    queryFn: getRecommendedNews(articleSlug),
    enabled: !!articleSlug
  });
